import React from "react";
import LandingPage from "./components/LandingPage"



function App() {
    return (
        <div>
            <LandingPage></LandingPage>
        </div>
    );
}

export default App;
